import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const LiveOrderFeed = () => {
  const [orders] = useState([
  {
    id: "ORD-2025-001234",
    customer: {
      name: "Sarah Johnson",
      avatar: "https://images.unsplash.com/photo-1587403655231-b1734312903f",
      avatarAlt: "Professional headshot of woman with brown hair in white blouse smiling at camera",
      phone: "+1 (555) 123-4567"
    },
    service: "Home Cleaning",
    provider: "CleanPro Services",
    amount: "$89.99",
    status: "in_progress",
    timeline: [
    { step: "Order Placed", completed: true, time: "10:30 AM" },
    { step: "Provider Assigned", completed: true, time: "10:45 AM" },
    { step: "Service Started", completed: true, time: "2:00 PM" },
    { step: "Service Completed", completed: false, time: "" },
    { step: "Payment Processed", completed: false, time: "" }],

    location: "Downtown, NYC",
    estimatedCompletion: "4:30 PM"
  },
  {
    id: "ORD-2025-001235",
    customer: {
      name: "Michael Chen",
      avatar: "https://images.unsplash.com/photo-1637080423110-6736ee5705ed",
      avatarAlt: "Professional headshot of Asian man with glasses in dark suit jacket",
      phone: "+1 (555) 987-6543"
    },
    service: "Food Delivery",
    provider: "QuickBite Restaurant",
    amount: "$34.50",
    status: "completed",
    timeline: [
    { step: "Order Placed", completed: true, time: "1:15 PM" },
    { step: "Restaurant Confirmed", completed: true, time: "1:20 PM" },
    { step: "Food Prepared", completed: true, time: "1:45 PM" },
    { step: "Out for Delivery", completed: true, time: "2:00 PM" },
    { step: "Delivered", completed: true, time: "2:25 PM" }],

    location: "Midtown, NYC",
    estimatedCompletion: "Completed"
  },
  {
    id: "ORD-2025-001236",
    customer: {
      name: "Emily Rodriguez",
      avatar: "https://images.unsplash.com/photo-1630949018486-5582dd02684d",
      avatarAlt: "Professional headshot of Hispanic woman with long dark hair in blue blazer",
      phone: "+1 (555) 456-7890"
    },
    service: "Property Viewing",
    provider: "Elite Realty Group",
    amount: "$0.00",
    status: "disputed",
    timeline: [
    { step: "Appointment Booked", completed: true, time: "9:00 AM" },
    { step: "Agent Assigned", completed: true, time: "9:15 AM" },
    { step: "Viewing Scheduled", completed: true, time: "11:00 AM" },
    { step: "Issue Reported", completed: true, time: "11:30 AM" },
    { step: "Dispute Resolution", completed: false, time: "" }],

    location: "Brooklyn, NYC",
    estimatedCompletion: "Pending Resolution"
  }]
  );

  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-blue-100 text-blue-800 border-blue-200',
      in_progress: 'bg-amber-100 text-amber-800 border-amber-200',
      completed: 'bg-emerald-100 text-emerald-800 border-emerald-200',
      cancelled: 'bg-gray-100 text-gray-800 border-gray-200',
      disputed: 'bg-red-100 text-red-800 border-red-200'
    };
    return colors?.[status] || colors?.active;
  };

  const getStatusLabel = (status) => {
    const labels = {
      active: 'Active',
      in_progress: 'In Progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
      disputed: 'Disputed'
    };
    return labels?.[status] || 'Unknown';
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-foreground">Live Order Feed</h2>
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-emerald-500 rounded-full pulse-status"></div>
            <span className="text-sm text-muted-foreground">Live Updates</span>
          </div>
        </div>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto">
        {orders?.map((order) =>
        <div key={order?.id} className="p-6 hover:bg-muted/50 transition-hover">
            {/* Order Header */}
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center space-x-3">
                <Image
                src={order?.customer?.avatar}
                alt={order?.customer?.avatarAlt}
                className="w-10 h-10 rounded-full object-cover" />

                <div>
                  <h3 className="font-medium text-foreground">{order?.customer?.name}</h3>
                  <p className="text-sm text-muted-foreground">{order?.id}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getStatusColor(order?.status)}`}>
                  {getStatusLabel(order?.status)}
                </span>
                <Button variant="ghost" size="icon" className="h-8 w-8">
                  <Icon name="MoreVertical" size={16} />
                </Button>
              </div>
            </div>

            {/* Order Details */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div>
                <p className="text-sm text-muted-foreground">Service</p>
                <p className="font-medium text-foreground">{order?.service}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Provider</p>
                <p className="font-medium text-foreground">{order?.provider}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Amount</p>
                <p className="font-medium text-foreground">{order?.amount}</p>
              </div>
            </div>

            {/* Timeline */}
            <div className="mb-4">
              <div className="flex items-center space-x-4 overflow-x-auto pb-2">
                {order?.timeline?.map((step, index) =>
              <div key={index} className="flex items-center space-x-2 min-w-0 flex-shrink-0">
                    <div className={`w-3 h-3 rounded-full ${
                step?.completed ? 'bg-emerald-500' : 'bg-gray-300'}`
                }></div>
                    <div className="min-w-0">
                      <p className={`text-xs font-medium ${
                  step?.completed ? 'text-foreground' : 'text-muted-foreground'}`
                  }>
                        {step?.step}
                      </p>
                      {step?.time &&
                  <p className="text-xs text-muted-foreground">{step?.time}</p>
                  }
                    </div>
                    {index < order?.timeline?.length - 1 &&
                <div className={`w-8 h-px ${
                step?.completed && order?.timeline?.[index + 1]?.completed ?
                'bg-emerald-500' : 'bg-gray-300'}`
                }></div>
                }
                  </div>
              )}
              </div>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                <div className="flex items-center space-x-1">
                  <Icon name="MapPin" size={14} />
                  <span>{order?.location}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Clock" size={14} />
                  <span>{order?.estimatedCompletion}</span>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Button variant="ghost" size="sm" iconName="Phone">
                  Contact
                </Button>
                <Button variant="outline" size="sm" iconName="Edit">
                  Manage
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default LiveOrderFeed;